import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import InvoiceToolHeader from './header/invoice-tool-header';
import PreviewInvoice from './preview-invoice/preview-invoice';
import WorkDetailsContainer from './work-details/work-details-container';
import PaymentDetails from './invoice-payment-details';
import SettingsTabWrapper from './settings/settings-tab-wrapper';
import Modal from 'react-modal';
import SentOrderModal from '../../components/modal/sent-order-modal/sent-order-modal';
import ConfirmInvoiceModal from '../../components/modal/confirm-invoice-modal/confirm-invoice-modal';
import ExceededWorkingHoursSurveyModal
  from '../../components/exceeded-working-hours-survey-modal/exceeded-working-hours-survey-modal';
import ConfirmPreregisterModal from '../../components/modal/confirm-preregister-modal/confirm-preregister-modal';
import RegisterAssignmentInfoModal
  from '../../components/modal/register-assignment-info-modal/register-assignment-info-modal';
import InvoiceToolCompleteInformationModal from './complete-information-modal/invoice-tool-complete-information-modal';
import InvoiceService from 'frilans-finans/invoices/invoice-service';
import CustomerService from 'frilans-finans/customers/customer-service';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';
import InvoiceCalculator from '../../components/invoice-calculator/invoice-calculator';
import TaxkeyService from 'frilans-finans/taxkeys/taxkey-service';
import SupplierLedgerListContainer from './distribution/supplier-ledger/list/supplier-ledger-list-container';
import Translate from 'react-translate-component';
import { GeneralError, CloseModal } from 'components';
import Ssnr from './ssnr/ssnr';
import InvoiceUserEntity from '../../frilans-finans/invoices/invoice-user-entity';
import counterpart from 'counterpart';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { getVatById, hasExceededWorkingHours } from './invoice-tool-helper';
import {
  SupplierLedgerService,
  UserSettingsConstants,
  WorkerService,
  UserService
} from 'frilans-finans';
import * as entities from 'selectors/entities';
import CookieUtils from 'frilans-finans/utils/cookie-utils';
import WorkDateHelper from './work-date/work-date-helper';
import InvoiceToolSelectVacationModal from './complete-information-modal/invoice-tool-select-vacation-modal';
import moment from 'moment';

const DEFAULT_COUNTRY = 'SWEDEN';
const NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID = 4;

export class InvoiceTool extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    taxkeys: PropTypes.array.isRequired,
    setUserId: PropTypes.func.isRequired,
    setTaxId: PropTypes.func.isRequired,
    setSaveVacationPay: PropTypes.func.isRequired,
    location: PropTypes.object,
    params: PropTypes.object,
    setAmount: PropTypes.func.isRequired,
    setCustomerId: PropTypes.func.isRequired,
    setCurrencyId: PropTypes.func.isRequired,
    setCurrencyName: PropTypes.func.isRequired,
    setCurrencyAmount: PropTypes.func.isRequired,
    setSpecification: PropTypes.func.isRequired,
    setInvoiceDate: PropTypes.func.isRequired,
    setInvoiceUser: PropTypes.func.isRequired,
    setInvoiceId: PropTypes.func.isRequired,
    setSupplierLedger: PropTypes.func.isRequired,
    setValid: PropTypes.func.isRequired,
    setPosting: PropTypes.func.isRequired,
    setPostError: PropTypes.func.isRequired,
    clearValidationErrors: PropTypes.func.isRequired,
    setSendToEmail: PropTypes.func.isRequired,
    setSendToEmailSecondary: PropTypes.func.isRequired,
    setSendToEmailBool: PropTypes.func.isRequired,
    setEinvoiceAddress: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    invoice: PropTypes.object,
    setLockAmountDistribution: PropTypes.func.isRequired,
    setInitializing: PropTypes.func.isRequired,
    setRot: PropTypes.func.isRequired,
    setRut: PropTypes.func.isRequired,
    setDisplayDates: PropTypes.func.isRequired,
    setDisplayHours: PropTypes.func.isRequired,
    setSubmitted: PropTypes.func.isRequired,
    setPreReport: PropTypes.func.isRequired,
    setPreReportedAt: PropTypes.func.isRequired,
    setTermsAccepted: PropTypes.func.isRequired,
    setExpressPayment: PropTypes.func.isRequired,
    setSupplierLedgerTypes: PropTypes.func.isRequired,
    setCouponId: PropTypes.func.isRequired,
    currencies: PropTypes.object.isRequired,
    setMessageType: PropTypes.func.isRequired,
    setSurveyAnswers: PropTypes.func.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  static childContextTypes = {
    user: React.PropTypes.object,
    taxkeys: React.PropTypes.array
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      fetchError: false,
      coworkers: [],
      settingsModalIsOpen: false,
      previewModalIsOpen: false,
      saveModalIsOpen: false,
      sendModalIsOpen: false,
      surveyModalIsOpen: false,
      supplierLedgerListModalIsOpen: false,
      ssnrModalIsOpen: false,
      user: props.user,
      taxkeys: props.taxkeys,
      invoice: null,
      invoiceLockError: false,
      postedInvoiceId: null,
      fetchingInvoice: false,
      loading: false,
      invoiceToolClientErrors: [],
      preReportInvoice: false,
      changedLanguage: false,
      originalLang: counterpart.getLocale(),
      sentPrereportModalIsOpen: false,
      sentInvoiceModalIsOpen: false,
      registerAssignmentTool: false,
      registerAssignmentInfoModalIsOpen: false,
      updated: false,
      invoiceToolCompleteInformationModalIsOpen: false,
      saveVacationModalIsOpen: false,
      hasOpenedVacationModal: false,
      userTotalHours: 0
    };

    this.openSupplierLedgerListModal = this.openSupplierLedgerListModal.bind(this);
    this.closeSupplierLedgerListModal = this.closeSupplierLedgerListModal.bind(this);
    this.openSsnrModal = this.openSsnrModal.bind(this);
    this.closeSsnrModal = this.closeSsnrModal.bind(this);
    this.openSettingsModal = this.openSettingsModal.bind(this);
    this.closeSettingsModal = this.closeSettingsModal.bind(this);
    this.openPreviewModal = this.openPreviewModal.bind(this);
    this.closePreviewModal = this.closePreviewModal.bind(this);
    this.openSaveModal = this.openSaveModal.bind(this);
    this.closeSaveModal = this.closeSaveModal.bind(this);
    this.openSendModal = this.openSendModal.bind(this);
    this.closeSendModal = this.closeSendModal.bind(this);
    this.openSurveyModal = this.openSurveyModal.bind(this);
    this.closeSurveyModal = this.closeSurveyModal.bind(this);
    this.openSentInvoiceModal = this.openSentInvoiceModal.bind(this);
    this.closeSentPrereportModal = this.closeSentPrereportModal.bind(this);
    this.postInvoice = this.postInvoice.bind(this);
    this.addTaxkeysToInvoiceUsers = this.addTaxkeysToInvoiceUsers.bind(this);
    this.createInvoiceUserEntity = this.createInvoiceUserEntity.bind(this);
    this.onClickSend = this.onClickSend.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.onUnload = this.onUnload.bind(this);
    this.handleInvoiceError = this.handleInvoiceError.bind(this);
    this.openInvoiceToolCompleteInformationModal = this.openInvoiceToolCompleteInformationModal.bind(this);
    this.closeSentInvoiceModal = this.closeSentInvoiceModal.bind(this);
    this.setInvoiceToolCompleteInformationModal = this.setInvoiceToolCompleteInformationModal.bind(this);
    this.setSaveVacationModal = this.setSaveVacationModal.bind(this);
    this.setErrors = this.setErrors.bind(this);
    this.newEmptyInvoice = this.newEmptyInvoice.bind(this);
    this.newEmptyPreregister = this.newEmptyPreregister.bind(this);
    this.toggleSentPrereportModal = this.toggleSentPrereportModal.bind(this);
    this.toggleSentInvoiceModal = this.toggleSentInvoiceModal.bind(this);
    this.toggleRegisterAssignmentInfoModal = this.toggleRegisterAssignmentInfoModal.bind(this);
    this.renderUpdatedModal = this.renderUpdatedModal.bind(this);
    this.closeUpdatingModal = this.closeUpdatingModal.bind(this);
    this.scrollCalendar = this.scrollCalendar.bind(this);
    this.shouldDisplaySaveVacationModal = this.shouldDisplaySaveVacationModal.bind(this);
  }

  componentDidMount () {
    if (this.props.location.pathname.includes('register')) {
      this.setState({
        registerAssignmentTool: true
      });

      if (!CookieUtils.getRegisterAssignmentToolVisited()) {
        this.setState({
          registerAssignmentInfoModalIsOpen: true
        });
        CookieUtils.setRegisterAssignmentToolVisited();
      }
    }

    if (!this.props.params || this.props.params.id === undefined) {
      // Clear redux form of any old data and add currently logged in user
      this.props.clear();
      let loggedInInvoiceUser = this.createInvoiceUserEntity(this.props.user);
      loggedInInvoiceUser.taxkeys = this.props.taxkeys;
      this.props.setInvoiceUser([loggedInInvoiceUser]);
    }

    if (this.props.params.id) {
      const invoiceId = this.props.params.id;
      InvoiceService.lockInvoice(invoiceId)
      .then((response) => {
        if (response.status !== 200) {
          this.setState({
            invoiceLockError: true
          });
        } else {
          window.addEventListener('beforeunload', this.onUnload);
        }
      })
      .catch(() => {
        // returns 423 when locked
        this.setState({
          invoiceLockError: true
        });
      });
    }

    SupplierLedgerService.getTypes().then((response) => {
      this.props.setSupplierLedgerTypes(response);
    });

    UserService.getHoursWorked(
      this.props.user.id,
      moment().subtract(1, 'years').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    ).then((response) => {
      this.state.userTotalHours = response.data.sum;
    });

    if (!this.props.params || this.props.params.id === undefined) {
      window.addEventListener('beforeunload', this.onUnload);
    }
  }

  componentWillUnmount () {
    this.props.clear();
    if (this.props.params.id && !this.state.invoiceLockError) {
      const invoiceId = this.props.params.id;
      InvoiceService.unlockInvoice(invoiceId)
      .then(() => {})
      .catch(() => {
        // catch to avoid error
      });
    }
    window.removeEventListener('beforeunload', this.onUnload);
  }

  onUnload (event) {
    event.returnValue = 'ask-before-leaving';
  }

  createInvoiceUserEntity (workerEntity) {
    let invoiceUserEntity = new InvoiceUserEntity(
      0,
      (workerEntity.address) ? workerEntity.address.co : workerEntity.co,
      (workerEntity.address) ? workerEntity.address.street : workerEntity.street,
      (workerEntity.address) ? workerEntity.address.zip : workerEntity.street,
      (workerEntity.address) ? workerEntity.address.city : workerEntity.street,
      (workerEntity.address) ? workerEntity.address.country : workerEntity.street,
      null,
      workerEntity.id,
      0,
      workerEntity.defaultTaxkeyId,
      0,
      workerEntity.firstName,
      workerEntity.lastName,
      workerEntity.accountClearingNumber || workerEntity.accountClearingNr,
      workerEntity.accountNumber || workerEntity.accountNr,
      null,
      false,
      '',
      workerEntity.saveVacationPay,
      workerEntity.saveItp,
      workerEntity.itpRate,
    );

    return invoiceUserEntity;
  }

  addTaxkeysToInvoiceUsers (workers) {
    let promises = [];

    const workerIds = workers.map(user => +user.userId)
      .filter(userId => userId !== +this.props.user.id);
    const invoiceOwner = workers.find(user => +user.userId === +this.props.user.id);
    invoiceOwner.taxkeys = this.props.taxkeys;

    if (workerIds.length) {
      promises.push(TaxkeyService.getWorkersTaxkeys(workerIds).then((response) => {
        response.forEach((item) => {
          const user = workers
            .find(worker => +worker.userId === +item.userId);
          if (user) user.taxkeys = item.taxkeys;
        });
      }));
    }

    return Promise.all(promises);
  }

  handleInvoiceResponse (data, supplierLedgers) {
    let currentExchangeRate = entities.selectById(this.props.currencies.list, data.currencyId).exchangeRate;
    let currencyAdjustedAmount = data.currencyAmount * currentExchangeRate;
    data.invoiceUsers = data.invoiceUsers.map((user) => {
      user.total = (user.total / data.amount) * currencyAdjustedAmount;
      return user;
    });

    this.props.clear();
    this.props.setInitializing(true);
    this.props.setUserId(data.userId);
    this.props.setTaxId(data.taxId);
    this.props.setCustomerId(data.companyId);
    this.props.setCurrencyId(data.currencyId);
    this.props.setCurrencyName(data.currencyName);
    this.props.setCurrencyAmount(data.currencyAmount);
    this.props.setAmount(currencyAdjustedAmount);
    this.props.setSpecification(data.specification);
    this.props.setInvoiceDate(data.invoiceDates);
    this.props.setInvoiceId(this.props.params.id);
    this.props.setSupplierLedger(supplierLedgers);
    this.props.setCouponId(data.couponId);
    this.props.setInvoiceUser(data.invoiceUsers);
    this.props.setInitializing(false);
    this.props.setSendToEmail(data.sendToEmail);
    this.props.setEinvoiceAddress(data.sendToEinvoiceAddress);
    this.props.setDisplayDates(data.displayDates);
    this.props.setDisplayHours(data.displayHours);

    this.props.setPreReport(data.preReport);
    this.props.setPreReportedAt(data.preReportedAt);
    this.props.setMessageType(data.messageType);

    this.handleWorkerLocking(currencyAdjustedAmount, data.invoiceUsers);

    data.sendToEmailBool = data.sendToEmail.length >= 1;
    this.props.setSendToEmailBool(data.sendToEmailBool);

    if (data.hsd.rot) {
      this.props.setRot(data.hsd.rot, data.hsd.data, data.hsd.apartmentNumber,
        data.hsd.cooperativeApartmentRegistrationNumber, data.hsd.accommodationType);
    } else if (data.hsd.rut) {
      this.props.setRut(data.hsd.rut);
    }

    if (data.invoiceUsers && data.invoiceUsers.length > 0 &&
      typeof data.invoiceUsers[0].expressPayment !== 'undefined') {
      this.props.setExpressPayment(data.invoiceUsers[0].expressPayment);
    }

    // We need to store this fields that are not saved in Redux because of the preview
    this.setState({
      invoice: data,
      fetchingInvoice: false
    });
  }

  handleWorkerLocking (currencyAdjustedAmount, invoiceUsers) {
    if (!invoiceUsers.length) {
      return;
    }
    const evenDividedAmount = currencyAdjustedAmount / invoiceUsers.length;
    const shouldLock = invoiceUsers.some((invoiceUser) => {
      return invoiceUser.total !== evenDividedAmount;
    });

    if (shouldLock) {
      const lockAmountDistribution = {};
      invoiceUsers.forEach((invoiceUser) => {
        lockAmountDistribution[invoiceUser.userId] = true;
      });
      this.props.setLockAmountDistribution(lockAmountDistribution);
    }
  }

  handleInvoiceError (error) {
    // Redirect on 403 Forbidden, otherwise show error
    if (error.response && error.response.status === 403) {
      this.context.router.replace('/activities');
    } else if (error.response !== undefined) {
      this.setState({
        fetchError: true
      });
    }
  }

  componentWillReceiveProps (nextProps) {
    const invoiceNotLoaded = !nextProps.invoice.invoiceId;
    const editingInvoice = nextProps.params && nextProps.params.id !== undefined;
    const currenciesLoaded = nextProps.currencies.list.length;
    const notFetchingInvoice = !this.state.fetchingInvoice;

    if (invoiceNotLoaded && editingInvoice && currenciesLoaded && notFetchingInvoice) {
      this.setState({
        fetchingInvoice: true
      }, async () => {
        try {
          const [data, supplierLedger] = await Promise.all([
            InvoiceService.getInvoiceByIdIncludeUsersDates(nextProps.params.id),
            InvoiceService.getSupplierLedgersForInvoice(nextProps.params.id)
          ]);
          await this.addTaxkeysToInvoiceUsers(data.invoiceUsers);
          this.handleInvoiceResponse(data, supplierLedger);
          this.fetchCoworkers(data.invoiceUsers);
        } catch (error) {
          this.handleInvoiceError(error);
        }
      });
    }

    this.setState({
      user: nextProps.user,
      taxkeys: nextProps.taxkeys
    });
    this.setUserDataToRedux(this.props.user);

    this.setVatAccordingToCustomer(this.props.invoice.customerEntity,
      nextProps.invoice.customerEntity);

    if (!nextProps.invoice.initializing) {
      let invoiceData = this.getInvoiceData(nextProps.invoice);
      this.validateInvoice(invoiceData);
    }

    if (nextProps.user.id && !nextProps.user.socialSecurityNr) {
      this.openSsnrModal();
    }
  }

  fetchCoworkers (workers) {
    const invoiceCoworkers = workers.filter(worker => +worker.userId !== +this.props.user.id);
    // TODO create backend endpoint to get all workers in one go
    invoiceCoworkers.forEach(coworker => {
      WorkerService.getWorker(coworker.userId)
        .then((response) => {
          this.handleFetchWorkerResponse(response);
        }).catch(() => {
          this.setState({
            fetchError: true
          });
        });
    });
  }

  handleFetchWorkerResponse (response) {
    let coworkers = this.state.coworkers;
    response.forEach(result => {
      if (this.props.invoice.invoiceUser.find(worker => +worker.userId === +result.id)) {
        coworkers.push(result);
      }
    });

    this.setState({
      coworkers: coworkers
    });
  }

  getChildContext () {
    return {
      user: this.state.user,
      taxkeys: this.state.taxkeys
    };
  }

  setUserDataToRedux (user) {
    if (!this.state.user && user) {
      this.props.setUserId(user.id);
      this.props.setSaveVacationPay(user.saveVacationPay);
    }
  }

  setVatAccordingToCustomer (prevCustomer, customer) {
    if (prevCustomer !== customer && customer !== null) {
      if (customer.address.country !== DEFAULT_COUNTRY) {
        this.props.setTaxId(NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID);
      }
    }
  }

  scrollToError () {
    const errors = [...document.querySelectorAll('.error')].filter(element => element.classList.length === 1);

    if (errors.length) {
      window.scrollTo(0, errors[0].getBoundingClientRect().top + window.scrollY - 300);
    }
  }

  scrollCalendar () {
    this.setState({
      surveyModalIsOpen: false
    });

    const calendar = document.querySelector('.work-date');

    window.scrollTo(0, calendar.getBoundingClientRect().top + window.scrollY - 30);
  }

  validateInvoice (invoice) {
    let isValid = InvoiceValidator.invoiceIsValid(invoice);

    if (this.props.invoice.valid !== isValid) {
      this.props.setValid(isValid);
    }

    if (!isValid) {
      this.scrollToError();
    }

    return isValid;
  }

  getTotalHours = () => {
    let hours = 0;
    this.props.invoice.invoiceDate.forEach(item => {
      hours += item.hours;
    });
    return hours;
  }

  getTotalGross = () => {
    let gross = 0;
    this.props.invoice.invoiceUser.forEach(invoiceUser => {
      gross += invoiceUser.calculation.gross;
    });
    return gross;
  }

  renderSettingsModal () {
    if (this.state.settingsModalIsOpen) {
      return (
        <Modal
          className='modal modal-wide settings-tab-modal'
          contentLabel=''
          isOpen={this.state.settingsModalIsOpen}
          onRequestClose={this.closeSettingsModal}>
          <div className='modal-content'>
            <SettingsTabWrapper closeSettingsModal={this.closeSettingsModal} />
          </div>
        </Modal>
      );
    }
  }

  closeUpdatingModal () {
    this.setState({
      updated: false
    });
    if (this.state.registerAssignmentTool) {
      this.redirectToPostedPrereport();
    } else {
      this.redirectToPostedInvoice();
    }
  }

  renderUpdatedModal () {
    let title = proxyCounterpart('INVOICE_TOOL_INVOICE_UPDATED_TITLE');
    let body = proxyCounterpart('INVOICE_TOOL_INVOICE_UPDATED_BODY');
    if (this.state.registerAssignmentTool) {
      title = proxyCounterpart('INVOICE_TOOL_ASSIGNMENT_UPDATED_TITLE');
      body = proxyCounterpart('INVOICE_TOOL_ASSIGNMENT_UPDATED_BODY');
    }

    if (this.state.updated) {
      return <CloseModal
        headline={title}
        body={body}
        close={this.closeUpdatingModal}
      />;
    }
  }

  renderSendModal () {
    if (this.state.sendModalIsOpen) {
      let currentExchangeRate = entities.selectById(this.props.currencies.list,
        this.props.invoice.currencyId).exchangeRate;
      let currencyAmount = (this.props.invoice.amount / currentExchangeRate).toFixed(2);

      return (<ConfirmInvoiceModal
        customer={this.props.invoice.customerEntity}
        amount={currencyAmount + ' ' + this.props.invoice.currencyName}
        invoice={this.props.invoice}
        callback={this.closeSendModal}
      />);
    }
  }

  renderSurveyModal () {
    const callback = (answers, status) => this.closeSurveyModal(answers, status);

    if (this.state.surveyModalIsOpen) {
      return (<ExceededWorkingHoursSurveyModal
        callback={callback}
        scrollCalendar={this.scrollCalendar}
      />);
    }
  }

  renderSaveModal () {
    if (this.state.saveModalIsOpen) {
      let currentExchangeRate = entities.selectById(this.props.currencies.list,
        this.props.invoice.currencyId).exchangeRate;
      let currencyAmount = (this.props.invoice.amount / currentExchangeRate).toFixed(2);

      const sortedWorkDates = this.props.invoice.invoiceDate.sort((date1, date2) => date1.date - date2.date);
      const firstWorkDate = sortedWorkDates[0].date;
      const lastWorkDate = sortedWorkDates[sortedWorkDates.length - 1].date;

      return (<ConfirmPreregisterModal
        customer={this.props.invoice.customerEntity}
        amount={currencyAmount + ' ' + this.props.invoice.currencyName}
        firstWorkDate={firstWorkDate}
        lastWorkDate={lastWorkDate}
        callback={this.closeSaveModal}
      />);
    }
  }

  renderInvoiceSentModal () {
    if (this.state.sentInvoiceModalIsOpen) {
      return (
        <SentOrderModal
          close={this.closeSentInvoiceModal}
          registerNew={this.newEmptyInvoice}
          title='SENT_INVOICE_MODAL_TITLE'
          translations={[
            'SENT_INVOICE_MODAL_INVOICE_CREATED',
            'SENT_INVOICE_MODAL_INVOICE_REVIEWED_BY_FF',
            'SENT_INVOICE_MODAL_SENT_TO_COMPANY'
          ]}
          registerButtonText='SENT_INVOICE_MODAL_INVOICE_AGAIN_BTN'
          doneButtonText='SENT_INVOICE_MODAL_DONE_BTN'
        />
      );
    }
  }

  newEmptyInvoice () {
    if (this.props.params.id) {
      this.context.router.push('/invoice-tool');
      window.removeEventListener('beforeunload', this.onUnload);
      location.reload();
    } else {
      window.removeEventListener('beforeunload', this.onUnload);
      location.reload();
    }
  }

  renderPrereportSentModal () {
    if (this.state.sentPrereportModalIsOpen) {
      return (
        <SentOrderModal
          close={this.closeSentPrereportModal}
          registerNew={this.newEmptyPreregister}
          title='SENT_PREREPORT_MODAL_TITLE'
          translations={[
            'SENT_PREREPORT_MODAL_REGISTERED',
            'SENT_PREREPORT_MODAL_WORK_DONE',
            'SENT_PREREPORT_MODAL_EASY_INVOICING'
          ]}
          registerButtonText='SENT_PREREPORT_MODAL_PREREGISTER_AGAIN_BTN'
          doneButtonText='SENT_PREREPORT_MODAL_DONE_BTN'
        />
      );
    }
  }

  newEmptyPreregister () {
    if (this.props.params.id) {
      this.context.router.push('/register-assignment');
      window.removeEventListener('beforeunload', this.onUnload);
      location.reload();
    } else {
      window.removeEventListener('beforeunload', this.onUnload);
      location.reload();
    }
  }

  renderSsnrModal () {
    if (this.state.ssnrModalIsOpen) {
      return (
        <Ssnr onCloseModal={this.closeSsnrModal} isOpen={this.state.ssnrModalIsOpen} />
      );
    }
  }

  renderPreviewModal () {
    if (this.state.previewModalIsOpen) {
      return (
        <Modal
          className='modal modal-wide invoice-preview-modal'
          contentLabel=''
          shouldCloseOnOverlayClick
          isOpen={this.state.previewModalIsOpen}
          onRequestClose={this.closePreviewModal}>
          <div className='modal-content'>
            <PreviewInvoice
              previewInvoice={this.props.invoice}
              previewSupplierLedgers={this.props.invoice.supplierLedger}
              closePreviewModal={this.closePreviewModal} />
          </div>
        </Modal>
      );
    }
  }

  renderSupplierLedgerListModal () {
    if (this.state.supplierLedgerListModalIsOpen) {
      return (
        <Modal
          className='modal supplier-ledger-list-modal'
          contentLabel=''
          isOpen={this.state.supplierLedgerListModalIsOpen}>
          <div className='modal-content'>
            <h2><Translate content={!this.state.preReport
              ? 'INVOICE_SENT' : 'INVOICE_SAVED_MODAL_TEXT'} />
            </h2>
            <p dangerouslySetInnerHTML={
              { __html: proxyCounterpart('WRITE_DOWN_LEVID_ON_RECEIPT') }
            } />
            <SupplierLedgerListContainer showDelete={false} />
            <div className='right-btn-wrapper'>
              <a className='btn blue continue-btn' onClick={this.closeSupplierLedgerListModal}>
                <span><Translate content='CONTINUE' /></span>
              </a>
            </div>
          </div>
        </Modal>
      );
    }
  }

  renderRegisterAssignmentModal () {
    if (this.state.registerAssignmentInfoModalIsOpen) {
      return <RegisterAssignmentInfoModal close={this.toggleRegisterAssignmentInfoModal} />;
    }
  }

  getInvoiceUsers (invoiceUser, expressPayment) {
    let invoiceUsers = [];

    for (let i = 0; i < invoiceUser.length; i++) {
      let user = invoiceUser[i];
      let isLoggedInUser = (parseInt(user.userId) === parseInt(this.props.user.id));
      let updatedWorker = this.state.coworkers.find(worker => +worker.id === +user.userId);
      if (updatedWorker) {
        user.saveItp = updatedWorker.saveItp;
      }

      let itpSetting = false;
      if (isLoggedInUser) {
        itpSetting = this.props.user.saveITP;
      } else if (user.saveItp) {
        itpSetting = user.saveItp;
      }

      invoiceUsers.push({
        user_id: parseInt(user.userId),
        taxkey_id: user.taxkeyId,
        total: String(user.total),
        travel: +user.travel,
        allowance: +user.allowance,
        save_vacation_pay: this.props.user.saveVacationPay || false,
        save_itp: itpSetting,
        itp_rate: (isLoggedInUser) ? this.props.user.itpRate : UserSettingsConstants.itpRateDefault,
        express_payment: expressPayment,
        gross: user.gross
      });
    }

    return invoiceUsers;
  }

  getInvoiceDate (invoiceDate) {
    let returnDate = [];

    for (let i = 0; i < invoiceDate.length; i++) {
      let date = invoiceDate[i];
      returnDate.push({
        date: date.date,
        hours: date.hours
      });
    }

    return returnDate;
  }

  getSupplierLedgers (supplierLedger) {
    let arr = [];

    for (let s of supplierLedger) {
      arr.push({
        supplier_name: s.supplierName,
        user_id: this.props.user.id,
        tax_id: s.taxId,
        supplier_ledger_type_id: s.supplierLedgerTypeId,
        amount: Math.round(s.amount / (1 + (getVatById(s.taxId) / 100))),
        id: s.id
      });
    }

    return arr;
  }

  getHsdData (hsddata) {
    return ({
      rot: hsddata.rot,
      rut: hsddata.rut,
      data: hsddata.data,
      apartment_number: hsddata.apartmentNumber,
      cooperative_apartment_registration_number: hsddata.cooperativeApartmentRegistrationNumber,
      accommodation_type: hsddata.accommodationType
    });
  }

  getInvoiceData (invoice) {
    let invoiceUsers = this.getInvoiceUsers(invoice.invoiceUser, invoice.expressPayment);
    let invoiceDate = this.getInvoiceDate(invoice.invoiceDate);
    let supplierLedgers = this.getSupplierLedgers(invoice.supplierLedger);
    let hsdData = this.getHsdData(invoice.hsd);
    let data = {
      specification: invoice.specification,
      user_id: parseInt(this.props.user.id),
      company_id: invoice.customerId,
      currency_id: invoice.currencyId,
      currency_amount: invoice.currencyAmount,
      amount: invoice.amount,
      tax_id: invoice.taxId,
      invoiceuser: invoiceUsers,
      invoicedate: invoiceDate,
      hsd: hsdData,
      display_dates: invoice.displayDates,
      display_hours: invoice.displayHours,
      message_type: invoice.messageType,
      po_number: invoice.poNumber
    };

    if (invoice.surveys.status !== '' && invoice.surveys.questions_and_answers !== '') {
      data.surveys = [invoice.surveys];
    }

    // Supplier Ledgers
    if (supplierLedgers.length > 0) {
      data.supplierledger = supplierLedgers;
    }

    // Coupon ID
    if (invoice.couponId !== '') {
      data.coupon_id = invoice.couponId;
    }
    // Billing email
    if (invoice.messageType === 'email' && invoice.sendToEmail) {
      data.send_to_email = invoice.sendToEmail;
    }

    // Secondary billing email
    if (invoice.messageType === 'email' && invoice.sendToEmailSecondary) {
      data.send_to_email_secondary = invoice.sendToEmailSecondary;
    }

    // Send To SMS
    if (invoice.messageType === 'sms' && invoice.companyPhone) {
      data.company_phone = invoice.companyPhone;
    }

    // Send To E-invoice
    if (invoice.messageType === 'e-invoice' && invoice.einvoiceAddress) {
      data.e_invoice_address = invoice.einvoiceAddress;
    }

    return data;
  }

  shouldDisplaySaveVacationModal () {
    return (this.props.user.saveVacationPay == null && !this.state.hasOpenedVacationModal) &&
      (this.state.userTotalHours + this.getTotalHours()) >= 480;
  }

  postInvoice (preReport, invoiceId) {
    let data = this.getInvoiceData(this.props.invoice);
    let { country } = (this.props.invoice.customerEntity) ? this.props.invoice.customerEntity.address : {};

    if (country !== 'SWEDEN' || (!data.hsd.rot && !data.hsd.rut)) {
      delete data.hsd;
    }

    data.pre_report = preReport;
    if (this.validateInvoice(data)) {
      this.props.setPosting(true);
      this.props.setPostError(false);
      this.props.clearValidationErrors();
      const method = invoiceId ? 'update' : 'post';
      // REMOVE SET ERRORS FUNCTION AND IF/ELSE WHEN JUST ARRIVED HAS CHANGED THEIR SYSTEM.
      this.setErrors();
      if (this.shouldDisplaySaveVacationModal()) {
        this.setSaveVacationModal(true);
      } else if (!this.state.invoiceToolClientErrors.length) {
        // Update customer billing emails
        const emails = {
          sendToEmail: data.send_to_email,
          sendToEmailSecondary: data.send_to_email_secondary
        };
        CustomerService.updateBillingEmails(data.company_id, emails);
        InvoiceService[method](data, invoiceId)
          .then((response) => {
            CustomerService.updateMessaging(data);
            return response;
          })
          .then((response) => {
            this.setPostedInvoiceId(response.data.data.id);
            if ((this.state.registerAssignmentTool && preReport && this.props.params.id) ||
              (!this.state.registerAssignmentTool && !!this.props.params.id && !this.state.invoice.preReport)) {
              this.setState({
                updated: true
              });
            } else {
              this.openSentInvoiceModal();
            }
            this.props.setPosting(false);
          }).catch((error) => {
            if (this.hasClientErrors(error.response.data.errors)) {
              this.openInvoiceToolCompleteInformationModal(preReport);
            }
            this.props.setPosting(false);
          });
      } else {
        this.openInvoiceToolCompleteInformationModal(preReport);
        this.props.setPosting(false);
      }
    }
  }

  // REMOVE SET ERRORS FUNCTION AND IF/ELSE WHEN JUST ARRIVED HAS CHANGED THEIR SYSTEM.
  setErrors () {
    this.state.invoiceToolClientErrors = [];
    if (!this.state.user.email) this.state.invoiceToolClientErrors.push('email');
    if (!this.state.user.address.city) this.state.invoiceToolClientErrors.push('city');
    if (!this.state.user.address.street) this.state.invoiceToolClientErrors.push('street');
    if (!this.state.user.address.zip) this.state.invoiceToolClientErrors.push('zip');
    if (!this.state.user.address.country) this.state.invoiceToolClientErrors.push('country');
    if (!this.state.user.accountClearingNr && this.state.user.internationalAccount === 'off') {
      this.state.invoiceToolClientErrors.push('account_clearing_number');
    }
    if (!this.state.user.accountNr && this.state.user.internationalAccount === 'off') {
      this.state.invoiceToolClientErrors.push('account_number');
    }
    if (!this.state.user.iban && this.state.user.internationalAccount === 'on') {
      this.state.invoiceToolClientErrors.push('iban');
    }
    if (!this.state.user.bic && this.state.user.internationalAccount === 'on') {
      this.state.invoiceToolClientErrors.push('bic');
    }
    if (!this.state.user.professionId) this.state.invoiceToolClientErrors.push('profession_id');
  }

  onClickSend (preReport = false) {
    this.setState({
      invoiceToolCompleteInformationModalIsOpen: false,
      submitted: true,
      preReport: preReport
    }, () => {
      this.props.setSubmitted(true);
      this.props.setPreReport(preReport);
      if (this.props.invoice.termsAccepted) {
        if (this.props.invoice.invoiceId) {
          this.postInvoice(preReport, this.props.invoice.invoiceId);
        } else {
          this.postInvoice(preReport);
        }
      }
    });
  }

  onClickSave () {
    this.onClickSend(true);
  }

  setPostedInvoiceId (invoiceId) {
    this.setState({
      postedInvoiceId: invoiceId
    });
  }

  toggleSentPrereportModal () {
    this.setState({
      sentPrereportModalIsOpen: !this.state.sentPrereportModalIsOpen
    });
  }

  toggleSentInvoiceModal () {
    this.setState({
      sentInvoiceModalIsOpen: !this.state.sentInvoiceModalIsOpen
    });
  }

  toggleRegisterAssignmentInfoModal () {
    this.setState({
      registerAssignmentInfoModalIsOpen: !this.state.registerAssignmentInfoModalIsOpen
    });
  }

  openSentInvoiceModal () {
    if (this.props.invoice.supplierLedger.length && !this.state.preReport) {
      this.openSupplierLedgerListModal();
      return;
    }
    if (this.state.preReport) {
      this.toggleSentPrereportModal();
      return;
    }
    this.toggleSentInvoiceModal();
  }

  closeSentPrereportModal () {
    this.toggleSentPrereportModal();
    this.redirectToPostedPrereport();
  }

  redirectToPostedPrereport () {
    this.context.router.replace('/economy/register-assignment');
  }

  closeSentInvoiceModal () {
    this.toggleSentInvoiceModal();
    this.redirectToPostedInvoice();
  }

  redirectToPostedInvoice () {
    this.context.router.replace(`economy/invoices/${this.state.postedInvoiceId}`);
  }

  openInvoiceToolCompleteInformationModal (preReport) {
    this.setState({
      invoiceToolCompleteInformationModalIsOpen: true,
      preReportInvoice: preReport
    });
  }

  setInvoiceToolCompleteInformationModal () {
    this.setState({
      invoiceToolCompleteInformationModalIsOpen: false
    });
  }

  setSaveVacationModal (value) {
    this.setState({
      saveVacationModalIsOpen: value,
      hasOpenedVacationModal: true
    });
  }

  openSupplierLedgerListModal () {
    this.setState({
      supplierLedgerListModalIsOpen: true
    });
  }

  closeSupplierLedgerListModal () {
    this.setState({
      supplierLedgerListModalIsOpen: false
    });
    this.redirectToPostedInvoice();
  }

  openSsnrModal () {
    this.setState({
      ssnrModalIsOpen: true
    });
  }

  closeSsnrModal () {
    if (!this.props.user.socialSecurityNr) {
      this.context.router.replace('activities');
    }

    this.setState({
      ssnrModalIsOpen: false
    });
  }

  openSettingsModal () {
    this.setState({
      settingsModalIsOpen: true
    });
  }

  closeSettingsModal () {
    this.setState({
      settingsModalIsOpen: false
    });
  }

  openPreviewModal () {
    this.props.setSubmitted(true);

    let data = this.getInvoiceData(this.props.invoice);
    let customerAdressCountry =
      this.props.invoice.customerEntity ? this.props.invoice.customerEntity.address.country : null;
    let isValidInvoice = this.validateInvoice(data);
    if (!isValidInvoice) {
      return false;
    }
    let viewportMeta = document.getElementById('viewport-meta');
    document.body.classList.toggle('is-invoice-previewing');
    viewportMeta.setAttribute('content', 'width=990');
    this.setState({
      previewModalIsOpen: isValidInvoice
    });
    if (customerAdressCountry && isValidInvoice) {
      this.setState({
        changedLanguage: true
      });
      customerAdressCountry !== 'SWEDEN' ? counterpart.setLocale('en') : counterpart.setLocale('se');
    }
  }

  closePreviewModal () {
    let viewportMeta = document.getElementById('viewport-meta');
    document.body.classList.toggle('is-invoice-previewing');
    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, user-scalable=no');
    this.setState({
      previewModalIsOpen: false
    });
    if (this.state.changedLanguage) {
      this.setState({
        changedLanguage: false
      });
      counterpart.setLocale(this.state.originalLang);
    }
  }

  openSendModal () {
    this.props.setSubmitted(true);

    let data = this.getInvoiceData(this.props.invoice);
    let isValidInvoice = this.validateInvoice(data);
    if (isValidInvoice && this.props.invoice.termsAccepted) {
      if (this.props.params.id) {
        this.onClickSend();
      } else {
        this.setState({
          sendModalIsOpen: true
        });
      }
    }
  }

  openSurveyModal () {
    this.setState({
      surveyModalIsOpen: true
    });
  }

  openSaveModal () {
    this.props.setSubmitted(true);

    let data = this.getInvoiceData(this.props.invoice);
    let isValidInvoice = this.validateInvoice(data);
    if (isValidInvoice && this.props.invoice.termsAccepted) {
      if (this.props.params.id) {
        this.onClickSend(true);
      } else {
        this.setState({
          saveModalIsOpen: true
        });
      }
    }
  }

  closeSendModal (sendInvoice) {
    this.setState({
      sendModalIsOpen: false
    });
    if (sendInvoice) {
      return this.onClickSend();
    }
  }

  closeSaveModal (sendInvoice) {
    this.setState({
      saveModalIsOpen: false
    });
    if (sendInvoice) {
      return this.onClickSend(true);
    }
  }

  closeSurveyModal (answers, status) {
    if (!answers) {
      this.setState({
        surveyModalIsOpen: false,
        saveModalIsOpen: false
      });
    } else {
      this.props.setSurveyAnswers(answers, status);
      this.setState({
        surveyModalIsOpen: false,
        sendModalIsOpen: true
      });
    }
  }

  renderError () {
    if (this.state.fetchError) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <GeneralError />
            </div>
          </div>
        </div>
      );
    }
  }

  hasClientErrors (errors) {
    this.setState({
      invoiceToolClientErrors: []
    });
    const userErrors = errors[0].detail.errors[Object.keys(errors[0].detail.errors)[0]];
    const clientErrors = [];

    if (userErrors) {
      for (var error in userErrors) {
        clientErrors.push(error);
      }
    }

    if (clientErrors.length) {
      this.setState({
        invoiceToolClientErrors: clientErrors
      });
      return true;
    }
    return false;
  }

  renderInvoiceLockError () {
    if (this.state.invoiceLockError) {
      return (
        <div className='invoice-lock-error-container'>
          <div className='invoice-lock-error'>
            <img src={require('images/icons/exclamation-circle.svg')}/>
            <p className="title"><Translate content='INVOICE_TOOL_LOCK_INVOICE_ERROR_TITLE' /></p>
            <br />
            <Translate content='INVOICE_TOOL_LOCK_INVOICE_ERROR_MESSAGE' />
            <br />
            <br />
            <Link to='/activities'><Translate content='BACK'/></Link>
          </div>
        </div>
      );
    }
  }

  renderInvoiceTool () {
    const translationPrefix = this.state.registerAssignmentTool ? 'REGISTER_ASSIGNMENT_' : '';
    let selectedDays = this.props.invoice ? WorkDateHelper.parseWorkDates(this.props.invoice.invoiceDate) : [];
    let showSurveyModal = !this.state.registerAssignmentTool && hasExceededWorkingHours(selectedDays);

    return (
      <div className='invoice-tool'>
        <InvoiceToolHeader
          translationPrefix={translationPrefix}
          openSettingsModal={this.openSettingsModal}
          closeSettingsModal={this.closeSettingsModal}
        />
        {this.renderError()}
        <div className='container'>
          <div className='row'>
            <WorkDetailsContainer
              registerAssignmentTool={this.state.registerAssignmentTool}
              translationPrefix={translationPrefix}
            />
          </div>
          <div className='row row-bottom-margin'>
            <PaymentDetails
              postInvoice={this.postInvoice}
              openPreviewModal={this.openPreviewModal}
              closePreviewModal={this.closePreviewModal}
              openSendModal={showSurveyModal ? this.openSurveyModal : this.openSendModal}
              closeSendModal={this.closeSendModal}
              onClickSave={showSurveyModal ? this.openSurveyModal : this.openSaveModal}
              translationPrefix={translationPrefix}
              registerAssignmentTool={this.state.registerAssignmentTool}
            />
          </div>
        </div>
        <InvoiceCalculator />
        {this.renderSettingsModal()}
        {this.renderPreviewModal()}
        {this.renderSendModal()}
        {this.renderSaveModal()}
        {this.renderSurveyModal()}
        {this.renderInvoiceSentModal()}
        {this.renderPrereportSentModal()}
        {this.renderUpdatedModal()}
        <InvoiceToolSelectVacationModal
          isOpen={this.state.saveVacationModalIsOpen}
          toggleModal={this.setSaveVacationModal}
          user={this.state.user}
          callback={this.postInvoice}
        />
        <InvoiceToolCompleteInformationModal
          invoiceToolCompleteInformationModalIsOpen={this.state.invoiceToolCompleteInformationModalIsOpen}
          preReport={this.state.preReportInvoice}
          toggleModal={this.setInvoiceToolCompleteInformationModal}
          createInvoice={this.onClickSend}
          saveInvoice={this.onClickSave}
          classes={'right-btn-wrapper'}
          user={this.state.user}
        />
        {this.renderSupplierLedgerListModal()}
        {this.renderSsnrModal()}
        {this.renderRegisterAssignmentModal()}
      </div>
    );
  }

  render () {
    return (
      <div>
        {this.renderInvoiceLockError()}
        {this.renderInvoiceTool()}
      </div>
    );
  }
}

export default InvoiceTool;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/invoice-tool.js
 **/